export enum ResponseStatus {
  None = 0,
  NeedsAction = 10,
  Declined = 20,
  Tentative = 30,
  Accepted = 40,
}
